'use strict';
const isDynpack = Odigeo.Utils.isRequestApp('dp');

module.exports = {
    isCorrupted: function($el, idx) {
        return this.model.get('idx') !== idx || this.view.$el[0] !== $el[0];
    },
    getIndex: function(idx) {
        var widgetIdx = this.options.idx;
        return Odigeo._.isUndefined(widgetIdx) ? idx : widgetIdx;
    },
    reinit: function($el, idx) {
        var view = this.view;
        view.setElement($el);
        view.$widget = view.$el;
        this.model.set('idx', idx, {silent: true});
        view.createSelectors({idx: idx});
        view.render();
        view.updateDomSelectorsToCache();
        this.stopListening();
        this.bindEvents();
        this.model.update($('#metadata' + idx));
    },
    rebuildWidgetIfNeeded: function(idx) {
        idx = this.getIndex(idx);
        var $el = this.view.getElement();
        if (this.isCorrupted($el, idx)) {
            this.reinit($el, idx);
        }
        return this;
    },

    updateFilter: function(idx) {
        this.view.updateFilter.apply(this.view, arguments);
    },

    initFilter: function(idx) {
        this.model.initModel.apply(this.model, arguments);
        this.rebuildWidgetIfNeeded(idx);
        this.view.initFilter.apply(this.view, arguments);
    },

    resetFilter: function(idx) {
        var resetModel = this.model.resetModel;
        var context = resetModel ? this.model : this.view;
        var method = resetModel || this.view.resetFilter;
        method.apply(context, arguments);
    },

    onFilter: function(params) {
        this.rebuildWidgetIfNeeded(params.tabId);
        this.view.onFilter.apply(this.view, arguments);
    },

    bindEvents: Odigeo._.noop,

    widgetType: 'filter',

    onCitiesFilter: function(params) {
        this.rebuildWidgetIfNeeded(params.tabId);
        this.view.onCitiesFilter(params);
    },

    sendRequestModel: function(requestType, idx) {
        this.rebuildWidgetIfNeeded(idx);
        var requestModel = this.model.getRequestModel(idx);
        Odigeo.trigger(this.widgetType + ':sendFilterModel', requestModel, requestType, idx);
    },

    triggerFilterChange: function() {
        if (isDynpack && Odigeo.SessionScope.flow === 'mobile') return;

        const model = this.model;
        const index = model.get('idx');

        Odigeo.trigger(this.widgetType + ':set-summary-tag', {
            id: this.getTagId(),
            index: index,
            filterName: this.name,
            type: this.filterType,
            container: this.options.container,
            active: model.isFilterApplied(),
            data: model.getTagInfo(),
        });

        Odigeo.trigger(this.widgetType + ':set-filter-title-active', {
            titleContainer: this.view.$el.parents().closest('li').find('.filter_title'),
            isFiltered: (this.model.isFilterApplied() || this.isSummaryTagApplied()),
            container: this.options.container,
        });
    },

    isSummaryTagApplied: function() {
        const emptySummaryTags = this.view.$el.closest('li').find('.summary_label:empty');
        const summaryTagsAvailable = this.view.$el.closest('li').find('.summary_label');
        return summaryTagsAvailable.length !== emptySummaryTags.length;
    },

    getTagId: function() {
        return this.name + '-' + this.model.get('idx');
    },

    buildOptions: function() {
        this.options = Odigeo._.defaults(Odigeo.parseOptions(this.options), {tests: {}});
    },

    init: function() {
        this.buildOptions();
        this.model.bindEvents();
        this.view.bindEvents();
    },
};
